var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { role: "main" } }, [
    _c("h1", { staticClass: "mt-3" }, [
      _vm._v(_vm._s(_vm.$t("Login.SessionExpired.Title")))
    ]),
    _vm._v(" "),
    _c("div", [
      _c("p", [_vm._v(_vm._s(_vm.$t("Login.SessionExpired.Description")))]),
      _vm._v(" "),
      _c(
        "form",
        {
          ref: "logoutForm",
          staticStyle: { display: "inherit" },
          attrs: { method: "post" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.logout($event)
            }
          }
        },
        [
          _c(
            "button",
            { staticClass: "btn btn-secondary", attrs: { type: "submit" } },
            [_vm._v(_vm._s(_vm.$t("Login.SessionExpired.Button")))]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }